export class DepthManager {
    static SATELLITE_NEAR = 0.1;
    static SATELLITE_FAR = 3e10; // 3496000000;
    static LOG_DEPTH_FC = 2.0 / Math.log2(DepthManager.SATELLITE_FAR + 1.0);
    static getConfig() {
        return {
            logDepthBufFC: this.LOG_DEPTH_FC,
            near: this.SATELLITE_NEAR,
            far: this.SATELLITE_FAR,
            useLogDepth: true,
        };
    }
    static setupDepthBuffer(gl) {
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL); // CRITICAL: Must be LEQUAL for log depth
        gl.clearDepth(1.0);
        gl.depthMask(true);
    }
    static getLogDepthVertCode() {
        return `
      if (logDepthBufFC > 0.0) {
        // Guard against non-positive or extremely large gl_Position.w values which
        // can produce NaNs or Infs when used inside a log2. Clamp to a sensible
        // positive minimum to keep depth calculations stable for very large world
        // coordinates (e.g. grid lines).
        float w = clamp(gl_Position.w, 1e-9, 1e20);
        gl_Position.z = (log2(1.0 + w) * logDepthBufFC - 1.0) * w;
      }
    `;
    }
    static getLogDepthFragCode() {
        // TODO: This doesn't work correctly - need to figure out why
        return `
      // float w = 1.0 / gl_FragCoord.w;  // Recover original gl_Position.w
      // gl_FragDepth = (log2(max(1e-6, 1.0 + w)) * logDepthBufFC - 1.0) * 0.5 + 0.5;
    `;
    }
}
